export const BrowserName = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  FIREFOX: 'Firefox',
  EDGE: 'Edge',
  OPERA: 'Opera',
  IE: 'IE',
  Ie: 'Ie',
}
